import api from './api';

export function getProfile() {
    return api.get('/auth/profile');
}

export function updateProfile(data) {
    return api.patch('/auth/profile', data);
}

export function uploadProfilePhoto(base64DataUrl) {
    return api.post('/auth/profile/photo', { photo: base64DataUrl });
}
